import { render } from "./ValidationTwoTransfertPage.vue?vue&type=template&id=98117ad0&ts=true"
import script from "./ValidationTwoTransfertPage.vue?vue&type=script&lang=ts"
export * from "./ValidationTwoTransfertPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__